import React from 'react';
import { Icon } from './Icon.js';
export const IconPriorityHighFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,12.25c-.192,0-.384-.073-.53-.22l-5.72-5.72L3.28,12.03c-.293,.293-.768,.293-1.061,0s-.293-.768,0-1.061l6.25-6.25c.293-.293,.768-.293,1.061,0l6.25,6.25c.293,.293,.293,.768,0,1.061-.146,.146-.338,.22-.53,.22Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconPriorityHighFill18.js.map